// The patient record: header, the four tabs, the شرح حال sections, the timeline.
export const record = {
  // ── the patient record ───────────────────────────────────────────────
  'record.notFound.title': 'این بیمار پیدا نشد',
  'record.notFound.body': 'ممکن است حذف شده باشد. به فهرست بیماران برگردید.',
  'record.notFound.action': 'بازگشت به بیماران',
  'record.tabs.overview': 'خلاصه',
  'record.tabs.history': 'شرح حال',
  'record.tabs.visits': 'ویزیت‌ها',
  'record.tabs.timeline': 'خط زمانی',
  'record.header.visits': 'ویزیت ×{{count}}',
  'record.header.lastVisit': 'آخرین ویزیت {{date}}',
  'record.header.archived': 'بایگانی‌شده',
  'record.header.archivedHint': 'برای شروع ویزیت، بیمار را از بایگانی خارج کنید.',
  'record.actions.startVisit': 'شروع ویزیت',
  'record.actions.continueVisit': 'ادامهٔ ویزیت باز',
  'record.actions.chat': 'گفتگو با دستیار',
  'record.actions.edit': 'ویرایش بیمار',
  'record.actions.archive': 'بایگانی',
  'record.actions.unarchive': 'خروج از بایگانی',
  'record.actions.delete': 'حذف',
  'record.saved': 'ذخیره شد.',
  'record.startVisit.title': 'شروع ویزیت',
  'record.startVisit.reason': 'علت مراجعه',
  'record.startVisit.reasonHelper': 'از شکایت اصلی پر شده است؛ اگر این ویزیت دربارهٔ چیز دیگری است تغییرش دهید.',
  'record.startVisit.submit': 'شروع ویزیت',
  'record.startVisit.alreadyOpen': 'ویزیت بازی وجود داشت — همان ادامه می‌یابد.',
  'record.overview.details': 'مشخصات',
  'record.overview.allergies': 'هشدار حساسیت',
  'record.overview.problems': 'مشکلات فعال',
  'record.overview.meds': 'داروهای فعلی',
  'record.overview.pendingOrders': 'دستورهای در انتظار',
  'record.overview.lastVisit': 'آخرین ویزیت',
  'record.overview.recentChats': 'گفتگوهای اخیر',
  'record.overview.noProblems': 'مشکل فعالی ثبت نشده است.',
  'record.overview.noMeds': 'داروی فعلی ثبت نشده است.',
  'record.overview.noOrders': 'دستوری در انتظار نیست.',
  'record.overview.noVisits': 'هنوز ویزیتی ثبت نشده است.',
  'record.overview.noChats': 'هنوز گفتگویی انجام نشده است.',
  'record.overview.openVisit': 'باز کردن ویزیت',
  'record.overview.fromHistory': 'از شرح حال',
  'record.overview.fromVisit': 'ویزیت {{n}}',
  'record.visits.empty.title': 'هنوز ویزیتی ثبت نشده',
  'record.visits.empty.body': 'ویزیتی شروع کنید تا یادداشت SOAP، تشخیص‌ها، نسخه و دستورات را مستند کنید.',
  'record.visits.columns.visit': 'ویزیت',
  'record.visits.columns.date': 'تاریخ',
  'record.visits.columns.reason': 'علت مراجعه',
  'record.visits.columns.status': 'وضعیت',
  'record.visits.columns.counts': 'تشخیص · دارو · دستور',
  'record.visits.columns.summary': 'خلاصه',
  'record.visits.openLabel': 'باز کردن ویزیت {{n}}',
  'record.timeline.empty.title': 'هنوز رویدادی ثبت نشده',
  'record.timeline.empty.body': 'ویزیت‌ها، یافته‌ها، تشخیص‌ها و دستورات به ترتیب زمان اینجا نمایش داده می‌شوند.',
  'record.timeline.outside': 'خارج از ویزیت',
  'record.timeline.filter': 'فیلتر بر اساس نوع',
  'record.history.hint': 'هفت بخش را بنویسید — همین است که دستیار می‌خواند.',
  'record.history.dictate': 'دیکته',
  'record.history.visitChip': 'ویزیت {{n}}',

  // ── timeline event types (BFF-derived) ───────────────────────────────
  'timeline.type.encounter_start': 'شروع ویزیت',
  'timeline.type.encounter_end': 'پایان ویزیت',
  'timeline.type.entry': 'بخش شرح حال',
  'timeline.type.diagnosis': 'تشخیص',
  'timeline.type.rx': 'نسخه',
  'timeline.type.order': 'دستور',
  'timeline.type.order_result': 'نتیجه',
  'timeline.type.thread': 'گفتگو',

  // ── شرح حال — the seven sections ─────────────────────────────────────
  'history.sections.chiefComplaint': 'شکایت اصلی',
  'history.sections.hpi': 'شرح حال بیماری فعلی',
  'history.sections.pmh': 'سابقهٔ بیماری‌های قبلی',
  'history.sections.medications': 'داروهای مصرفی',
  'history.sections.allergies': 'حساسیت‌ها',
  'history.sections.vitals': 'علائم حیاتی',
  'history.sections.labs': 'آزمایش‌ها',
  'history.empty.title': 'هنوز چیزی اینجا نوشته نشده',
  'history.empty.body': 'این بخش را بنویسید؛ همین است که دستیار می‌خواند.',
  'history.add': 'افزودن',
  'history.entry.label': 'عنوان',
  'history.entry.labelPlaceholder': 'آزمایش خون ۱۴۰۵/۰۵/۱۲',
  'history.entry.body': 'آنچه می‌خواهید ثبت کنید',
  'history.entry.bodyPlaceholder': 'همان‌طور بنویسید که شفاهی می‌گویید.',
  'history.entry.recordedAt': 'زمان وقوع در داستان بیمار',
  'history.entry.recordedAtHelper': 'اختیاری است و معمولاً خالی می‌ماند.',
  'history.entry.sourceLabel': 'ثبت‌شده توسط',
  'history.entry.source.manual': 'خودتان',
  'history.entry.source.voice': 'خودتان، از پیش‌نویس صوتی',
  'history.entry.source.ai': 'خودتان، از پیشنهاد هوش مصنوعی',
  'history.entry.needsContent': 'چیزی بنویسید یا دست‌کم یک ردیف را پر کنید.',
  'history.delete.title': 'این بخش حذف شود؟',
  'history.delete.body': 'فقط همین بخش حذف می‌شود؛ باقی پرونده باقی می‌ماند.',
  'history.saved': 'شرح حال ذخیره شد.',
  'history.deleted': 'بخش حذف شد.',
  'history.structured.title': 'مقادیر ساختاریافته',
  'history.structured.helper': 'اختیاری است. متنی که بالا نوشته‌اید حامل اصلی پرونده است.',
  'history.vitals.bp': 'فشار خون',
  'history.vitals.hr': 'ضربان قلب',
  'history.vitals.rr': 'تعداد تنفس',
  'history.vitals.temp': 'دما',
  'history.vitals.spo2': 'اشباع اکسیژن',
  'history.units.bpm': 'در دقیقه',
  'history.units.perMin': 'در دقیقه',
  'history.units.celsius': 'درجه',
  'history.units.percent': 'درصد',
  'history.labs.name': 'آزمایش',
  'history.labs.value': 'مقدار',
  'history.labs.unit': 'واحد',
  'history.labs.ref': 'محدودهٔ مرجع',
  'history.labs.addRow': 'افزودن ردیف',
  'history.labs.removeRow': 'حذف این ردیف',
};

export default record;
